import { KaraokeText } from '../../KaraokeText';
import type { MultilingualPreviewState } from '../hooks/useMultilingualPreview';

/** 「▶ 多言語を通しで試聴」ボタン。操作ボタンの行に置く。 */
export function MultilingualPreviewButton({
  state,
  testIdSuffix,
  disabled,
}: {
  state: MultilingualPreviewState;
  testIdSuffix: string;
  disabled: boolean;
}): React.JSX.Element {
  return (
    <button
      type="button"
      data-testid={`preview-multilingual-${testIdSuffix}`}
      disabled={!state.playing && disabled}
      onClick={state.toggle}
    >
      {state.playing ? '■ 試聴を停止' : '▶ 多言語を通しで試聴'}
    </button>
  );
}

/**
 * 多言語の通し試聴の再生中の文面とエラー。
 * 通常の試聴 (`<audio>` の下) と同じ、操作ボタンの行の外に置く。
 */
export function MultilingualPreviewStatus({
  state,
  testIdSuffix,
}: {
  state: MultilingualPreviewState;
  testIdSuffix: string;
}): React.JSX.Element {
  return (
    <>
      {state.karaoke.current ? (
        <KaraokeText
          text={state.karaoke.current.text}
          progress={state.karaoke.current.progress}
          label={state.karaoke.current.label}
          testId={`preview-karaoke-multilingual-${testIdSuffix}`}
        />
      ) : null}
      {state.error ? (
        <div className="error-message" role="alert">
          {state.error}
        </div>
      ) : null}
    </>
  );
}
